<template>
  <cookie-law
    theme="blood-orange"
    storageType="localStorage"
    button-text="Zustimmen"
    :button-decline="true"
    button-decline-text="Ablehnen"
    button-decline-class="Cookie__button"
    :button-link="{ name: 'Privacy' }"
    button-link-text="Weitere Informationen"
    :message="message"
    @accept="enableTracking"
  />
</template>

<script>
 import CookieLaw from 'vue-cookie-law'

 export default {
   components: { CookieLaw },
   data() {
     return {
       message: "Diese Seite verwendet Cookies, um Ihnen ein besseres Nutzererlebnis bieten zu können."
     }
   },
   methods: {
     enableTracking() {
      //  this.$gtag.enable()
     this.$gtag.config({
        enabled: true
      });
     }
   }
 }
</script>
